
import { combineReducers } from "redux";

import userReducer from "./user/slice";
import agentReducer from "./agent/slice";


export default combineReducers({
    user: userReducer,
    agent: agentReducer,
})